import willieChat from'../images/willieChat.png'
import phoebeChat from'../images/phoebeChat.png'
import lakeBG from'../images/lake_bg.png'
import phoebeStuckTree from'../images/phoebeStuckTree.gif'
import phoebeStuckTreeGettingOut from'../images/phoebeStuckTreeGettingOut.png'
import dickWatching from'../images/dickWatching.png'
import dickWatching2 from'../images/dickWatching2.png'
import dickWatching3 from'../images/dickWatching3.png'
import dickWatching4 from'../images/dickWatching4.png'
import dickWatching5 from'../images/dickWatching5.png'
import dickWatching6 from'../images/dickWatching6.png'
import dickWatching7 from'../images/dickWatching7.png'
import dickWatching8 from'../images/dickWatching8.png'
import dickWatching9 from'../images/dickWatching9.png'
import dickWatching10 from'../images/dickWatching10.png'
import dickWatching11 from'../images/dickWatching11.png'
import evilAngel1 from'../images/evilAngel1.png'
import evilAngel2 from'../images/evilAngel2.png'
import evilAngel3 from'../images/evilAngel3.png'
import phoebeBurger from'../images/phoebeBurger.png'
import phoebeUpsideDown from'../images/phoebeUpsideDown.gif'
import phoebeUpsideDown2 from'../images/phoebeUpsideDown2.png'
import phoebeUpsideDown3 from'../images/phoebeUpsideDown3.png'
import phoebeUpsideDown4 from'../images/phoebeUpsideDown4.png'
import phoebeUpsideDown5 from'../images/phoebeUpsideDown5.png'
import phoebeUpsideDown6 from'../images/phoebeUpsideDown6.png'
import phoebeUpsideDown7 from'../images/phoebeUpsideDown7.png'
import phoebeCunnilingus from'../images/phoebeCunnilingus.png'
import phoebeCunnilingus2 from'../images/phoebeCunnilingus2.png'
import phoebeCunnilingus3 from'../images/phoebeCunnilingus3.png'
import phoebeCunnilingus4 from'../images/phoebeCunnilingus4.png'
import phoebeCunnilingus5 from'../images/phoebeCunnilingus5.png'
import phoebeCunnilingus6 from'../images/phoebeCunnilingus6.png'
import phoebeCunnilingus7 from'../images/phoebeCunnilingus7.png'
import phoebeCunnilingus8 from'../images/phoebeCunnilingus8.png'
import phoebeCunnilingus9 from'../images/phoebeCunnilingus9.png'
import phoebeCunnilingus10 from'../images/phoebeCunnilingus10.png'
import phoebeCunnilingus11 from'../images/phoebeCunnilingus11.png'
import phoebeCunnilingus12 from'../images/phoebeCunnilingus12.png'
import phoebeCunnilingus13 from'../images/phoebeCunnilingus13.png'
import phoebeCunnilingus14 from'../images/phoebeCunnilingus14.png'
import phoebeCunnilingus15 from'../images/phoebeCunnilingus15.png'
import phoebeCunnilingus16 from'../images/phoebeCunnilingus16.png'
import phoebeCunnilingus17 from'../images/phoebeCunnilingus17.png'
import phoebeCunnilingus18 from'../images/phoebeCunnilingus18.png'
import phoebeCunnilingus19 from'../images/phoebeCunnilingus19.png'
import phoebeCunnilingus20 from'../images/phoebeCunnilingus20.png'
import phoebeCunnilingus21 from'../images/phoebeCunnilingus21.png'
import phoebeCunnilingus22 from'../images/phoebeCunnilingus22.png'
import phoebeCunnilingus23 from'../images/phoebeCunnilingus23.png'
import phoebeCunnilingus24 from'../images/phoebeCunnilingus24.png'
import phoebeCunnilingus25 from'../images/phoebeCunnilingus25.png'
import phoebeCunnilingus26 from'../images/phoebeCunnilingus26.png'
import phoebeCunnilingus27 from'../images/phoebeCunnilingus27.png'
import phoebeCunnilingus28 from'../images/phoebeCunnilingus28.png'
import phoebeCunnilingus29 from'../images/phoebeCunnilingus29.png'
import phoebeCunnilingus30 from'../images/phoebeCunnilingus30.png'
import phoebeCunnilingus31 from'../images/phoebeCunnilingus31.png'
import phoebeCumming from'../images/phoebeCumming.gif'
import phoebeCumming2 from'../images/phoebeCumming2.png'
import phoebeCumming3 from'../images/phoebeCumming3.png'
import phoebeCumming4 from'../images/phoebeCumming4.png'
import phoebeCumming5 from'../images/phoebeCumming5.png'
import phoebeCumming6 from'../images/phoebeCumming6.png'
import phoebeCumming7 from'../images/phoebeCumming7.png'
import phoebeCumming8 from'../images/phoebeCumming8.png'
import phoebeCumming9 from'../images/phoebeCumming9.png'
import phoebeCumming10 from'../images/phoebeCumming10.png'
import phoebeCumming11 from'../images/phoebeCumming11.png'
import phoebeCumming12 from'../images/phoebeCumming12.png'
import phoebeCumming13 from'../images/phoebeCumming13.png'
import phoebeCumming14 from'../images/phoebeCumming14.png'
import phoebeCumming15 from'../images/phoebeCumming15.png'
import theWets from'../images/theWets.png'
import evilAngelCunnilingus from'../images/evilAngelCunnilingus.png'
import evilAngelCunnilingus2 from'../images/evilAngelCunnilingus2.png'
import evilAngelCunnilingus3 from'../images/evilAngelCunnilingus3.png'
import evilAngelCunnilingus4 from'../images/evilAngelCunnilingus4.png'
import evilAngelCunnilingus5 from'../images/evilAngelCunnilingus5.png'
import phoebeMessage from'../audio/phoebeMessage.mp3'
import phoebeMessage2 from'../audio/phoebeMessage2.mp3'
import characters from'./characters';
import achievements from'./achievements';
import gallery from'./gallery';
import natureAmbient from'../m/natureAmbient.js'
import discovering from'../m/discovering.js'
import quirkyForest from'../m/quirkyForest.js'
import buzzing from'../m/buzzing.js'
import poof from'../m/poof.js'
import thinking from'../m/thinking.js'
import shiny from'../m/shiny.js'
import quirkyForest2 from'../m/quirkyForest2.js'
import grass from'../m/grass.js'
import fight from'../m/fight.js'
import vinyl from'../m/vinyl.js'
import vibrator from'../m/vibrator.js'
import hollow from'../m/phoebe/hollow.js'
import hollow3 from'../m/phoebe/hollow3.js'
import gig from'../m/phoebe/gig.js'
import gig2 from'../m/phoebe/gig2.js'
import moan0 from'../m/phoebe/moan0.js'
import moan1 from'../m/phoebe/moan1.js'
import moan2 from'../m/phoebe/moan2.js'
import moan3 from'../m/phoebe/moan3.js'
import moan4 from'../m/phoebe/moan4.js'
import moan5 from'../m/phoebe/moan5.js'
import moan6 from'../m/phoebe/moan6.js'
import moan7 from'../m/phoebe/moan7.js'
import moan8 from'../m/phoebe/moan8.js'
import moan9 from'../m/phoebe/moan9.js'
import moan10 from'../m/phoebe/moan10.js'
import moan11 from'../m/phoebe/moan11.js'
import moan12 from'../m/phoebe/moan12.js'
import moan13 from'../m/phoebe/moan13.js'
import moan14 from'../m/phoebe/moan14.js'
import moan15 from'../m/phoebe/moan15.js'
import breathing from'../m/phoebe/breathing.js'
import hemhem from'../m/phoebe/hemhem.js'
import hmm from'../m/phoebe/hmm.js'
import notificationSound from'../m/notification.js'

const chapter3ru = [
  {chat:true, from:{name:"Фиби", photo:phoebeChat},
   messages: [
     {text:"Ты сделал домашку по секспросвету?", from:'messageFromHer', answers:["Эмм.. Ну да","Оно разве для всех?"]},
     {text:"Ой, блин, сорян😭", from:'messageFromHer', answered:"Эмм.. Ну да"},
     {text:"Я не про это, ахах", from:'messageFromHer', answered:"Эмм.. Ну да"},
     {text:"Хм.. Не знаю", from:'messageFromHer', answered:"Оно разве для всех?"},
     {text:"Вроде да..", from:'messageFromHer', answered:"Оно разве для всех?"},
     {text:"Хотяяя... Ты и так его выполнил на прошлом занятии😈", from:'messageFromHer', answered:"Оно разве для всех?", endofAnswer:true},
     {text:"Кароооче... Пара уже завтра, а у меня пока вообще не получается с дз", from:'messageFromHer'},
     {text:"Как назло все дома... Даже (гр)ебаная Урсула", from:'messageFromHer'},
     {text:"Я даже комнату то не могу закрыть...", from:'messageFromHer'},
     {text:"Сюда в целом заходят в любое время, а про постучаться вообще никто не слышал", from:'messageFromHer', answers:["Знакомо...","Может в ванной?"]},
     {text:"И даже в ванну не пойти!", from:'messageFromHer', answered:"Знакомо..."},
     {text:"Замок сломан", from:'messageFromHer', answered:"Знакомо..."},
     {text:"А даже если б не был, Урсула сидит там уже часа 2 наверное", from:'messageFromHer', answered:"Знакомо..."},
     {text:"Да, тоже об этом подумала", from:'messageFromHer', answered:"Может в ванной?"},
     {text:"Но замок не работает", from:'messageFromHer', answered:"Может в ванной?"},
     {text:"А даже если бы и работал, Урсула сидит там уже часа 2 наверное", from:'messageFromHer', answered:"Может в ванной?", endofAnswer:true},
     {text:"Надеюсь, у нее понос!", from:'messageFromHer'},
     {text:"Илии... стоп..", from:'messageFromHer'},
     {text:"ЁБУШКИ ВОРОБУШКИ! Даже думать не хочу об этом🙈", from:'messageFromHer'},
     {text:"Я просто хочу свою квартиру...", from:'messageFromHer'},
     {text:"Или чтобы ко мне ХОТЯ БЫ СТУЧАЛИСЬ..", from:'messageFromHer'},
     {text:"Мне тут вообще не расслабиться", from:'messageFromHer'},
     {text:"Бляять...", from:'messageFromHer'},
     {text:"Ладно, может, ночью с этим будет получше...", from:'messageFromHer'},
     {text:"Доброй ночи!✨", from:'messageFromHer', endOfChat:true},
  ]
  },
  {blackScreen:true, txt:["<h2>*Утро*</h2>"]},
  {chat:true, from:{name:"Фиби", photo:phoebeChat},
   messages: [
     {text:"Доброе!", from:'messageFromHer'},
     {text:"Как я могла забыть!", from:'messageFromHer'},
     {text:"Гороскоп на сегодня, ВНИМАНИЕ: Побудьте наедине с собой, общайтесь только с самыми близкими♊", from:'messageFromHer'},
     {text:"Кажется, это знак!", from:'messageFromHer'},
     {text:"Мне нужно тихое и уединенное место, чтобы никто не отвлекал", from:'messageFromHer'},
     {text:"Я такое знаю!", from:'messageFromHer'},
     {text:"Правда оно не совсем уединенное..", from:'messageFromHer'},
     {text:"Сможешь помочь?", from:'messageFromHer'},
     {text:"Please please please💃🏼🎤", from:'messageFromHer', answers:["Окей, а как?","А у меня есть выбор?"]},
     {text:"Спасибооо!!!", from:'messageFromHer', answered:"Окей, а как?"},
     {text:"Нуу, в принципе, можешь меня просто загостить🚩🚩", from:'messageFromHer', answered:"А у меня есть выбор?"},
     {text:"(даже и не думай)", from:'messageFromHer', answered:"А у меня есть выбор?"},
     {text:"Ладно", from:'messageFromMe', answered:"А у меня есть выбор?"},
     {text:"Спасибо!", from:'messageFromHer', answered:"А у меня есть выбор?", endofAnswer:true},
     {text:"Ты же знаешь, где черепашье озеро?", from:'messageFromHer'},
     {text:"Которое в парке недалеко от ВСЕГЕИ", from:'messageFromHer'},
     {text:"Там так тихо и умиротворенно", from:'messageFromHer'},
     {text:"Я ходила туда, когда готовилась к экзаменам...", from:'messageFromHer'},
     {text:"Но даже там иногда ходят люди..", from:'messageFromHer'},
     {text:"Но! У меня есть ты!", from:'messageFromHer'},
     {text:"Ты посмотришь, чтобы никого не было рядом, пока я...", from:'messageFromHer'},
     {text:"Эээ.. Делаю домашку!", from:'messageFromHer'},
     {text:"И нет, не волнуйся, мы не опоздаем к мисс Райдер🤞", from:'messageFromHer'},
	 {text:"Ладно, я тогда побежала завтракать!", from:'messageFromHer'},
	 {text:"Встретимся через час! Я скину гео как буду там!", from:'messageFromHer'},
	 {text:"Поки!", from:'messageFromHer', endOfChat:true},

  ]
  },

  {blackScreen:true, txt:["<h2>*Черепашье озеро*</h2>"]},

  {novel:true, background:lakeBG, startCoordinates:100,
  script:[
    {phoebesComfort:true, set:1, achievementCondition: true, achievementConditionSet:true},
    {char:characters["empty"],  position:"center", coordinates: 80, speed:3, transitionMode:"slow",
    phrases:[
      {text:"Таак, ну вот и озеро, но...", ambientStart:natureAmbient, loopTimeAmbient:300, ambientSettings:[0.2, 1200]},
    ]
    },
    {char:characters["empty"],  position:"center", coordinates: 20, speed:3, transitionMode:"slow",
    phrases:[
      {text:"Где же Фиби?"},
    ]
    },
    {char:characters["phoebe"],  position:"center", coordinates: 40, speed:1.4,
    phrases:[
      {text:"Дик!", soundEffect:hollow, soundEffectVolume:0.2},
    ]
    },
    {scene:true, img:phoebeStuckTree, start:true, time:300, gallery:gallery[22], musicStart:discovering, loopTime:2000, musicSettings:[0.3, 2200], soundEffectPre:hollow3, soundEffectVolume:0.2},
    {scene:true, name:characters["phoebe"].nameRu, position:"center",
    phrases:[
      {text:"Дик! Это ты?"},
      {text:"Пожалуйста помоги!!"},
      {text:"Я застряла..."},
      {text:"Попробуй взять меня за талию или.. бедра и.."},
    ]},
    {scene:true, endOfScene:true, time:10, skip:true},
    {scene:true, img:phoebeStuckTreeGettingOut, start:true, actionEvent:true, time:300, skip:true, skipFirstTap:true},
    {scene:true, name:characters["phoebe"].nameRu, position:"center",
    phrases:[
      {text:"Ага-а-а"},
      {text:"Таак, а теперь на счет три - тяни!"},
      {text:"ТРИ!", actionStart:["Tap"], musicEnd:true, musicSettings:2000},
    ]},
    {endOfNovel:true}
  ]},

  {novel:true, background:lakeBG, startCoordinates:0,
  script:[
    {char:characters["phoebe"],  position:"right", coordinates: 20, speed:2, transitionMode:"slow",
    phrases:[
      {text:"Ахахах", emotion:characters["phoebe"].standingLaughingWild, achievement:achievements[16], ambientStart:natureAmbient, loopTimeAmbient:300, ambientSettings:[0.2, 1200], musicStart:quirkyForest, loopTime:20000, musicSettings:[0.3, 2200], soundEffect:gig, soundEffectVolume:0.5},
      {text:"Пасиба!", emotion:characters["phoebe"].standingNeutralWild},
      {text:"Я просто... Искала птенчиков..", emotion:characters["phoebe"].standingNeutralWild},
    ]
    },
    {char:characters["dick"],  position:"left", coordinates: 15, speed:1,
    phrases:[
      {text:"...", emotion:characters["dick"].standingNeutral, answers:["Нашла?", "Что это у тебя на лице?"]},
    ]
    },
      {option:"Нашла?", start:true},
      {char:characters["dick"],  position:"left", coordinates: 15, speed:1,
      phrases:[
        {text:"Нашла?", emotion:characters["dick"].standingNeutral},
      ]
      },
      {char:characters["phoebe"],  position:"right", coordinates: 20, speed:1,
      phrases:[
        {text:"Неа, никого там нет...", emotion:characters["phoebe"].standingNeutralWild},
        {text:"Только мусор и окурки", emotion:characters["phoebe"].standingFrustratedWild},
      ]
      },
      {option:"Нашла?", endOfOption:true},

      {option:"Что это у тебя на лице?", start:true},
      {char:characters["dick"],  position:"left", coordinates: 15, speed:1,
      phrases:[
        {text:"Что это у тебя на лице?", emotion:characters["dick"].standingNeutral},
      ]
      },
      {char:characters["phoebe"],  position:"right", coordinates: 20, speed:1,
      phrases:[
        {text:"Это для маскировки!", emotion:characters["phoebe"].standingSmilingWild},
        {text:"Чтобы спрятаться в траве если что.", emotion:characters["phoebe"].standingEyebrowUpWild},
      ]
      },
      {option:"Что это у тебя на лице?", endOfOption:true, endOfOptions:true},

      {char:characters["phoebe"],  position:"right", coordinates: 20, speed:1,
      phrases:[
        {text:"Так, ну что, я готова!", emotion:characters["phoebe"].standingSmilingWild},
      ]
      },
      {char:characters["dick"],  position:"left", coordinates: 15, speed:1,
      phrases:[
        {text:"Ты будешь тут... Типо это.. Да?", emotion:characters["dick"].standingEmbarassedQuestion},
      ]
      },
      {char:characters["phoebe"],  position:"right", coordinates: 20, speed:1,
      phrases:[
        {text:"Ну-у-у, природа мне всегда помогала...", emotion:characters["phoebe"].standingNeutralWild},
        {text:"Думаю, лучше места и быть не может", emotion:characters["phoebe"].standingSmilingWild},
        {text:"Только.. Надеюсь, что никто меня не увидит", emotion:characters["phoebe"].standingEmbarassedWild},
        {text:"Так что стой тут и смотри, чтобы никого не было...", emotion:characters["phoebe"].standingSmilingWild},
        {text:"Если что, кричи... Эээмм...", emotion:characters["phoebe"].standingThinkingWild},
        {text:"В общем, просто кричи!", emotion:characters["phoebe"].standingLaughingWild},
        {text:"И-и-и еще...", emotion:characters["phoebe"].standingNeutralWild},
        {text:"Обещаешь, что не будешь подглядывать?", emotion:characters["phoebe"].standingEyebrowUpWild, answers:["Хорошо, обещаю", "Нуу.. Сделаю все что в моих силах."]},
      ]
      },

      {option:"Хорошо, обещаю", start:true},
      {phoebesComfort:true, plus:-0.1},
      {char:characters["phoebe"],  position:"right", coordinates: 20, speed:1,
      phrases:[
        {text:"Спасибо!", emotion:characters["phoebe"].standingSmilingWild},
      ]
      },
      {option:"Хорошо, обещаю", endOfOption:true},

      {option:"Нуу.. Сделаю все, что в моих силах.", start:true},
      {phoebesComfort:true, plus:-0.05},
      {char:characters["phoebe"],  position:"right", coordinates: 20, speed:1,
      phrases:[
        {text:"Спасибо..", emotion:characters["phoebe"].standingEyebrowUpNeutralWild, note:"Phoebe feels uncomfortable"},
      ]
      },
      {option:"Нуу.. Сделаю все, что в моих силах.", endOfOption:true, endOfOptions:true},

      {char:characters["phoebe"],  position:"right", coordinates: 20, speed:1,
      phrases:[
        {text:"Нуу кхмм.. Я тогда пойду", emotion:characters["phoebe"].standingEmbarassedWild},
        {text:"И не подслушивай!", emotion:characters["phoebe"].standingLaughingWild},
      ]
      },
    {endOfNovel:true, musicContinue:true}
  ]},

  {novel:true, background:dickWatching, startCoordinates:0,
  script:[
    {char:characters["phoebe"],  position:"center", coordinates: 0, speed:1,
    phrases:[
      {text:"Ну все, я начинаю!", answers:["Удачи!", "Хорошо, я тогда смотрю!"], ambientStart:natureAmbient, loopTimeAmbient:300, ambientSettings:[0.2, 1200], musicStart:quirkyForest, loopTime:20000, musicSettings:[0.3, 2200]},
    ]
    },
    {option:"Удачи!", start:true},
    {changeBG:true, img:dickWatching2, smooth:true},
    {char:characters["dick"],  position:"center", coordinates: 0, speed:1,
    phrases:[
      {text:"Удачи!"},
    ]
    },
    {char:characters["phoebe"],  position:"center", coordinates: 0, speed:1,
    phrases:[
      {text:"Спасибо! Ахах"},
    ]
    },
    {option:"Удачи!", endOfOption:true},

    {option:"Хорошо, я тогда смотрю!", start:true},
    {char:characters["dick"],  position:"center", coordinates: 0, speed:1,
    phrases:[
      {text:"Хорошо, я тогда смотрю!"},
    ]
    },
    {changeBG:true, img:dickWatching2, smooth:true},
    {char:characters["dick"],  position:"center", coordinates: 0, speed:1,
    phrases:[
      {text:"В смысле... не на тебя..."},
    ]
    },
    {char:characters["phoebe"],  position:"center", coordinates: 0, speed:1,
    phrases:[
      {text:"Ахахах, я поняла!"},
    ]
    },
    {option:"Хорошо, я тогда смотрю!", endOfOption:true, endOfOptions:true},

    {changeBG:true, img:dickWatching, smooth:true},
    {char:characters["empty"],  position:"center", coordinates: 0, speed:1,
    phrases:[
      {text:"..."},
      {text:"*пение птиц*", ambientChangeSettings:[0.6, 700]},
      {text:"*БЗЗЗ*", ambientChangeSettings:[0.2, 700], soundEffect:buzzing, soundEffectVolume:0.5},
    ]
    },
    {changeBG:true, img:dickWatching11, smooth:true},
    {char:characters["dick"],  position:"center", coordinates: 0, speed:1,
    phrases:[
      {text:"Ой, господи, это что?!!"},
      {text:"Ненавижу жуков!"},
    ]
    },
    {char:characters["phoebe"],  position:"center", coordinates: 0, speed:1,
    phrases:[
      {text:"Не переживай!"},
      {text:"Наверняка это просто пчелка опыляет цветочек"},
    ]
    },
    {changeBG:true, img:dickWatching, smooth:true},
    {char:characters["dick"],  position:"center", coordinates: 0, speed:1,
    phrases:[
      {text:"Ну ладно..."},
    ]
    },
    {changeBG:true, img:dickWatching3, smooth:true},
    {char:characters["empty"],  position:"center", coordinates: 0, speed:1,
    phrases:[
      {text:"*Хмм.. Так тихо*"},
    ]
    },
    {changeBG:true, img:dickWatching4, smooth:true},
    {char:characters["empty"],  position:"center", coordinates: 0, speed:1,
    phrases:[
      {text:"*Интересно, она и правда сейчас мастурбирует..*"},
      {text:"*Интересно, а внутри или снаружи...*"},
    ]
    },
    {changeBG:true, img:dickWatching5, smooth:true},
    {char:characters["empty"],  position:"center", coordinates: 0, speed:1,
    phrases:[
      {text:"*ЕПТЫТЬ?!*", soundEffectPre:poof, soundEffectVolume:0.2},
    ]
    },
    {endOfNovel:true}
  ]},

  {novel:true, background:evilAngel1, startCoordinates:0,
  script:[
    {char:characters["evilRyder"],  position:"center", coordinates: 0, speed:1.7,
    phrases:[
      {text:"Я знаю, ты очень хочешь это узнать, Ричард", musicStart:thinking, loopTime:5000, musicSettings:[0.3, 2200]},
      {text:"Так чего же ты ждешь?"},
      {text:"Она тут, прямо позади тебя"},
    ]
    },
    {changeBG:true, img:evilAngel2, smooth:true},
    {char:characters["angelRyder"],  position:"center", coordinates: 100, speed:1.7, transitionMode:"slow",
    phrases:[
      {text:"Ричард, нет!"},
      {text:"Ей сейчас нужно уединение и эмоциональный комфорт"},
    ]
    },
    {changeBG:true, img:evilAngel3, smooth:true},
    {char:characters["angelRyder"],  position:"center", coordinates: 100, speed:1.7, transitionMode:"slow",
    phrases:[
      {text:"И ты как раз таки с этим помогаешь!"},
      {text:"Не подглядывай, ты можешь все испортить!"},
    ]
    },
    {char:characters["evilRyder"],  position:"center", coordinates: 0, speed:1.7, transitionMode:"slow", changeBGTransition:evilAngel1,
    phrases:[
      {text:"Не слушай ее, Ричард, я знаю, Фиби сама хочет, чтобы ты посмотрел"},
      {text:"И ты, конечно, тоже?"},
    ]
    },
    {changeBG:true, img:evilAngel2, smooth:true},
    {char:characters["angelRyder"],  position:"center", coordinates: 100, speed:1.7, transitionMode:"slow",
    phrases:[
      {text:"Нет! Не слушай ее!"},
      {text:"Я знаю, что очень хочется, но ты можешь удовлетворить свои желания другим безопасным способом"},
    ]
    },
    {changeBG:true, img:evilAngel3, smooth:true},
    {char:characters["angelRyder"],  position:"center", coordinates: 100, speed:1.7, transitionMode:"slow",
    phrases:[
      {text:"Используй В-О-О-Б-Р-А-Ж-Е-Н-И-Е!"},
    ]
    },
    {endOfNovel:true}
  ]},

  {novel:true, background:dickWatching6, startCoordinates:0,
  script:[
    {char:characters["phoebe"],  position:"center", coordinates: 0, speed:1,
    phrases:[
      {text:"Ммм-хммм...", ambientStart:natureAmbient, startPointAmbient:10, loopTimeAmbient:300, ambientSettings:[0.2, 1200], soundEffect:moan0, soundEffectVolume:0.05},
    ]
  },
  {char:characters["phoebe"],  position:"center", coordinates: 0, speed:1,
  phrases:[
    {text:"<small><i>*быстро дышит*</small></i>", soundEffect:breathing, soundEffectVolume:0.3},
  ]
},
  {char:characters["dick"],  position:"center", coordinates: 0, speed:1,
  phrases:[
    {text:"Бляять! Что делать...", answers:["Фантазировать", "Подглядеть"], timer:3},
  ]
},

{option:"Фантазировать", start:true},
{scene:true, img:phoebeBurger, start:true, time:300, gallery:gallery[23], soundEffectPre:shiny, soundEffectVolume:0.3, ambientChangeSettings:[0.6, 1000]},
{scene:true, name:characters["phoebe"].nameRu, position:"center", dialogCoordinates:"55vh",
phrases:[
  {text:"Ты сегодня вообще успел поесть?", achievement:achievements[17]},
  {text:"Так торопился мне помочь, наверное, даже пропустил завтрак"},
  {text:"Хочешь покушать?"},
  {text:"Она очень вкусная и питательная", soundEffectPre:gig2, soundEffectVolume:0.7},
  {text:"А этот соус добавит пикантности"},
]},
{scene:true, endOfScene:true, time:300, endOfSceneLoadNext:true, dialogCoordinates:"60vh", ambientChangeSettings:[0.2, 1000]},
{char:characters["dick"],  position:"center", coordinates: 0, speed:1, changeBGTransition:dickWatching10,
phrases:[
  {text:"..."},
]
},
{changeBG:true, img:dickWatching7, smooth:true},
{char:characters["phoebe"],  position:"center", coordinates: 0, speed:1,
phrases:[
  {text:"Дик?"},
]
},
{option:"Фантазировать", endOfOption:true},

{option:"Skip", start:true},
{char:characters["phoebe"],  position:"center", coordinates: 0, speed:1,
phrases:[
  {text:"Дик?"},
]
},
{changeBG:true, img:dickWatching7, smooth:true},
{option:"Skip", endOfOption:true},

{option:"Подглядеть", start:true},
{phoebesComfort:true, plus:-0.47},
{changeBG:true, img:dickWatching8, smooth:true},
{char:characters["dick"],  position:"center", coordinates: 0, speed:1,
phrases:[
  {text:"Лаадно, одним глазком..."},
]
},
{changeBG:true, img:dickWatching7, smooth:true},
{char:characters["phoebe"],  position:"center", coordinates: 100, speed:1, transitionMode:"slow",
phrases:[
  {text:"Дик, даже и не думай!!!", note:"Фиби некомфортно", soundEffect:hemhem, soundEffectVolume:0.3},
  {text:"Это только мешает!"},
  {text:"Лучше смотри за обстановкой вокруг!"},
]
},
{char:characters["dick"],  position:"center", coordinates: 0, speed:1, transitionMode:"slow", changeBGTransition:dickWatching9,
phrases:[
  {text:"..."},
]
},
{option:"Подглядеть", endOfOption:true, endOfOptions:true},

{char:characters["phoebe"],  position:"center", coordinates: 0, speed:1,
phrases:[
  {text:"Ну что, видел кого-нибудь?", musicStart:quirkyForest2, loopTime:100, musicSettings:[0.3, 2200]},
]
},
{changeBG:true, img:dickWatching8, smooth:true},
{char:characters["dick"],  position:"center", coordinates: 0, speed:1,
phrases:[
  {text:"Не-а! Никого! Все чисто!"},
]
},
{changeBG:true, img:dickWatching7, smooth:true},
{char:characters["phoebe"],  position:"center", coordinates: 0, speed:1,
phrases:[
  {text:"Да блять!"},
  {text:"Я.. Я не понимаю.."},
  {text:"Что я делаю не так?!"},
  {text:"Может.. эмм.. может поможешь мне тут..? Пожалуйста?"},
  {text:"Ну типа..."},
  {text:"Ты же опытный теперь, ну, наверное..."},
]
},
{scene:true, img:phoebeUpsideDown, start:true, time:300, gallery:gallery[24], ambientChangeSettings:[0.05, 1000]},
{scene:true, name:characters["phoebe"].nameRu, position:"center", dialogCoordinates:"65vh",
phrases:[
  {text:"Как тебе ракурс? ахаха"},
  {text:"Мммм...", soundEffectPre:moan1, soundEffectVolume:0.1},
  {text:"Мне так приятно, но когда доходит до оргазма, у меня не получается.."},
  {text:"Я.. Я просто.. Я уже почти все перепробовала!"},
]},
{scene:true, img:phoebeUpsideDown2, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].nameRu, position:"center",
phrases:[
  {text:"Даже ту штуку с ускорением и замедлением, как вы делали со Стейси..."},
]},
{scene:true, img:phoebeUpsideDown4, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].nameRu, position:"center",
phrases:[
  {text:"Не помогает"},
  {text:"Прям вообще…"},
]},
{scene:true, img:phoebeUpsideDown3, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].nameRu, position:"center",
phrases:[
  {text:"А я так хочу кончить"},
]},
{scene:true, img:phoebeUpsideDown4, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].nameRu, position:"center",
phrases:[
  {text:"Что не так то...", answers:["А тебе удобно так лежать?", "Думаю, это просто по-разному у всех работает"]},
]},

{option:"А тебе удобно так лежать?", start:true},
{scene:true, img:phoebeUpsideDown3, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].nameRu, position:"center",
phrases:[
  {text:"Нуу.. даа"},
  {text:"Вроде"},
]},
{scene:true, img:phoebeUpsideDown4, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].nameRu, position:"center",
phrases:[
  {text:"Не знаю..."},
  {text:"Я обычно лежала так в ванной"},
]},
{option:"А тебе удобно так лежать?", endOfOption:true},

{option:"Думаю, это просто по-разному у всех работает", start:true},
{scene:true, img:phoebeUpsideDown5, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].nameRu, position:"center",
phrases:[
  {text:"Ну, да... Думаю, ты прав"},
]},
{scene:true, img:phoebeUpsideDown6, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].nameRu, position:"center",
phrases:[
  {text:"Я раньше ложилась так в душе и..."},
]},
{option:"Думаю, это просто по-разному у всех работает", endOfOption:true, endOfOptions:true},


{scene:true, img:phoebeUpsideDown7, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].nameRu, position:"center",
phrases:[
  {text:"И там была эта насадочка.."},
  {text:"Очень.. хорошая..."},
  {text:"Было так мокро, я всегда представляла что это как оральный секс"},
]},
{scene:true, img:phoebeUpsideDown6, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].nameRu, position:"center",
phrases:[
  {text:"Сейчас.."},
  {text:"Секунду"},
]},
{scene:true, endOfScene:true, time:10, skip:true, soundEffectPre:grass, soundEffectVolume:0.05},
{scene:true, img:phoebeCunnilingus, start:true, time:1700, skip:true, skipFirstTap:true, gallery:gallery[25]},
{scene:true, name:characters["phoebe"].nameRu, position:"center", dialogCoordinates:"8vh",
phrases:[
  {text:"Да, так удобнее"},
]},
{scene:true, img:phoebeCunnilingus2, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].nameRu, position:"center",
phrases:[
  {text:"А знаешь... Меня это все еще возбуждает..."},
  {text:"Представлять, что кто-то ласкает меня языком, хихи.."},
]},
{scene:true, img:phoebeCunnilingus3, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].nameRu, position:"center",
phrases:[
  {text:"Эмм"},

]},
{scene:true, img:phoebeCunnilingus4, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].nameRu, position:"center",
phrases:[
  {text:"Я тут подумала, может..."},
]},
{scene:true, img:phoebeCunnilingus5, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].nameRu, position:"center",
phrases:[
  {text:"Ты бы мог мне помочь?"},
]},
{scene:true, img:phoebeCunnilingus6, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].nameRu, position:"center",
phrases:[
  {text:"В плане, как друг подруге..."},
]},
{scene:true, img:phoebeCunnilingus7, changeScene:true, slowMode:true},
{scene:true, name:characters["empty"].nameRu, position:"center",
phrases:[
  {text:"...", soundEffectPre:poof, soundEffectVolume:0.2},
]},
{endOfNovel:true}
  ]},

{novel:true, background:evilAngelCunnilingus, startCoordinates:100,
script:[
  {char:characters["angelRyder"],  position:"center", coordinates: 100, speed:1.7,
  phrases:[
    {text:"Ричард, не смей!", musicStart:thinking, loopTime:5000, musicSettings:[0.3, 2200]},
    {text:"Незащищенный оральный секс очень опасен!"},
    {text:"Можно подхватить все что угодно"},
  ]
  },
  {char:characters["evilRyder"],  position:"center", coordinates: 0, speed:1.7, transitionMode:"slow",
  phrases:[
    {text:"Не слушай ты ее!"},
    {text:"Она всегда была занудой!"},
    {text:"Посмотри на нее, она так этого хочет, разве ты можешь ей отказать?"},
  ]
  },
  {char:characters["angelRyder"],  position:"center", coordinates: 100, speed:1.7, changeBGTransition:evilAngelCunnilingus2,
  phrases:[
    {text:"Сначала нужно убедится, что вы оба здоровы!"},
    {text:"Или использовать латексную салфетку!"},
  ]
  },
  {char:characters["evilRyder"],  position:"center", coordinates: 0, speed:1.7, transitionMode:"slow",
  phrases:[
    {text:"Да заткнись ты уже, дура!", musicEnd:true, musicSettings:300, soundEffect:vinyl, soundEffectVolume:0.3},
  ]
  },
  {char:characters["empty"],  position:"center", coordinates: 50, speed:1.7, transitionMode:"slow", changeBGTransition:evilAngelCunnilingus3,
  phrases:[
    {text:"...", soundEffect:fight, soundEffectVolume:0.5},
  ]
  },
  {changeBG:true, img:evilAngelCunnilingus4},
  {char:characters["empty"],  position:"center", coordinates: 50, speed:1.7, transitionMode:"slow", changeBGTransition:evilAngelCunnilingus3,
  phrases:[
    {text:"*звуки драки*"},
  ]
  },
  {changeBG:true, img:evilAngelCunnilingus5, smooth:true},
  {char:characters["evilRyder"],  position:"center", coordinates: 50, speed:1.7, transitionMode:"slow",
  phrases:[
    {text:"Только попробуй ей теперь отказать, Ричард!"},
  ]
  },
  {endOfNovel:true}
]},

{novel:true, background:lakeBG, startCoordinates:0,
script:[
{scene:true, img:phoebeCunnilingus8, start:true, time:300, skipFirstTap:true, gallery:gallery[26]},
{scene:true, name:characters["phoebe"].nameRu, position:"center", dialogCoordinates:"60vh",
phrases:[
{text:"Так что, мог бы?", answers:["Ага, мог бы","Да, конечно"], ambientStart:natureAmbient, loopTimeAmbient:300, ambientSettings:[0.1, 1200]},
]},
{option:"Ага, мог бы", start:true},
{scene:true, name:characters["phoebe"].nameRu, position:"center", dialogCoordinates:"8vh",
phrases:[
{text:"Волнительно, да?"},
]},
{option:"Ага, мог бы", endOfOption:true},

{option:"Да, конечно", start:true},
{scene:true, name:characters["phoebe"].nameRu, position:"center", dialogCoordinates:"8vh",
phrases:[
{text:"Волнительно, да?"},
]},
{option:"Да, конечно", endOfOption:true, endOfOptions:true},

{scene:true, img:phoebeCunnilingus9, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].nameRu, position:"center",
phrases:[
{text:"Мне тоже..."},
{text:"У меня.. у меня это первый раз..."},
{text:"В смысле... с кем то"},
]},
{scene:true, img:phoebeCunnilingus8, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].nameRu, position:"center",
phrases:[
{text:"Может подойдешь поближе?", musicStart:quirkyForest2, loopTime:100, musicSettings:[0.3, 2200]},
]},
{scene:true, img:phoebeCunnilingus11, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].nameRu, position:"center",
phrases:[
{text:"Ммм..."},
]},
{scene:true, img:phoebeCunnilingus10, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].nameRu, position:"center", dialogCoordinates:"60vh",
phrases:[
{text:"Ну что, похоже на бургер? Ахаха", answers:["Ну да, типо","Как то не очень"]},
]},

{option:"Ну да, типо", start:true},
{phoebesComfort:true, plus:0.01},
{scene:true, name:characters["phoebe"].nameRu, position:"center", dialogCoordinates:"8vh",
phrases:[
{text:"Я же говорила! Ахах", soundEffectPre:gig2, soundEffectVolume:0.5},
]},
{scene:true, img:phoebeCunnilingus10, changeScene:true, slowMode:true},
{option:"Ну да, типо", endOfOption:true},

{option:"Как то не очень", start:true},
{scene:true, img:phoebeCunnilingus12, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].nameRu, position:"center", dialogCoordinates:"8vh",
phrases:[
{text:"Аа, да?", soundEffectPre:hmm, soundEffectVolume:0.3},
]},
{scene:true, img:phoebeCunnilingus10, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].nameRu, position:"center",
phrases:[
{text:"Хмм, наверное, зависит от ракурса!"},
]},
{option:"Как то не очень", endOfOption:true, endOfOptions:true},

{scene:true, name:characters["phoebe"].nameRu, position:"center",
phrases:[
{text:"Ммм.. Пожалуйста, будь очень аккуратен..."},
]},
{scene:true, img:phoebeCunnilingus13, changeScene:true, slowMode:true},
{scene:true, name:characters["empty"].nameRu, position:"center",
phrases:[
{text:"...", actionStart:["Hold", ["35vw","65vh"]], autoPlay:1300, musicChangeSettings:[0.25, 700], musicChangeSpeed:[0.98,700], ambientChangeSpeed:[0.98,700]},
]},
{scene:true, img:phoebeCunnilingus14, changeScene:true, slowMode:true, gallery:gallery[27]},
{scene:true, name:characters["phoebe"].nameRu, position:"center",
phrases:[
{text:"Ммпх!", musicChangeSettings:[0.3, 1000], ambientChangeSpeed:[1,200], musicChangeSpeed:[1,200], soundEffectPre:moan11, soundEffectVolume:0.2},
]},
{scene:true, img:phoebeCunnilingus10, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].nameRu, position:"center",
phrases:[
{text:"Ваау..."},
{text:"Это очень круто"},
]},
{scene:true, img:phoebeCunnilingus12, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].nameRu, position:"center", dialogCoordinates:"60vh",
phrases:[
{text:"Там же не пахнет?", answers:["Нет-нет!","Да нормально в целом"], timer:2.5, autoPlay:2000},
]},

{option:"Нет-нет!", start:true},
{phoebesComfort:true, plus:0.01},
{scene:true, img:phoebeCunnilingus10, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].nameRu, position:"center", dialogCoordinates:"8vh",
phrases:[
{text:"Ну ладно, ахаха", achievement:achievements[18], soundEffectPre:gig, soundEffectVolume:0.15},
{text:"А то я подумала.."},
]},
{option:"Нет-нет!", endOfOption:true},

{option:"Да нормально в целом", start:true},
{phoebesComfort:true, plus:-0.1},
{scene:true, name:characters["phoebe"].nameRu, position:"center", dialogCoordinates:"8vh",
phrases:[
{text:"Ээ.. Ну ладно..", note:"Фиби некомфортно", soundEffectPre:hmm, soundEffectVolume:0.23},
]},
{option:"Да нормально в целом", endOfOption:true},

{option:"Skip", start:true},
{phoebesComfort:true, plus:-0.1},
{scene:true, name:characters["phoebe"].nameRu, position:"center", dialogCoordinates:"8vh",
phrases:[
{text:"Нуу.. Надеюсь нет...", note:"Фиби некомфортно", soundEffectPre:hmm, soundEffectVolume:0.23},
]},
{option:"Skip", endOfOption:true, endOfOptions:true},

{scene:true, img:phoebeCunnilingus13, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].nameRu, position:"center",
phrases:[
{text:"Можешь опуститься чуть пониже теперь?", actionStart:["Slider", ["35vw","55vh"], "down", "200", "low"], autoPlay:900},
]},
{scene:true, img:phoebeCunnilingus15, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].nameRu, position:"center",
phrases:[
{text:"Ооо даааа, во-о-от тут", soundEffectPre:moan7, soundEffectVolume:0.22},
{text:"Это даже лучше, чем та насадка для душа", autoPlay:1600},
{text:"Так приятно..", autoPlay:900},
]},
{scene:true, img:phoebeCunnilingus16, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].nameRu, position:"center",
phrases:[
{text:"А теперь по бокам", actionStart:["Slider", ["35vw","65vh"], "right","150","low", 3]},
]},
{scene:true, img:phoebeCunnilingus17, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].nameRu, position:"center",
phrases:[
{text:"Ах!", actionStart:["Slider", ["65vw","65vh"], "left","150","medium", 3], soundEffectPre:moan3, soundEffectVolume:0.22},
]},
{scene:true, img:phoebeCunnilingus18, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].nameRu, position:"center",
phrases:[
{text:"Даа, продолжай вот так", actionStart:["Hold", ["35vw","65vh"], , , , 3.5], musicChangeSettings:[0.25, 700], musicChangeSpeed:[0.98,700], ambientChangeSpeed:[0.98,700], soundEffectPre:moan9, soundEffectVolume:0.22},
]},
{scene:true, img:phoebeCunnilingus19, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].nameRu, position:"center",
phrases:[
{text:"Ага-а-а, а теперь чуть выше", actionStart:["Slider", ["50vw","50vh"], "up","250","low", 2], musicChangeSettings:[0.3, 500], musicChangeSpeed:[1,200], ambientChangeSpeed:[1,200], soundEffectPre:moan7, soundEffectVolume:0.22},
]},
{scene:true, img:phoebeCunnilingus20, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].nameRu, position:"center",
phrases:[
{text:"ММмм", soundEffectPre:moan10, soundEffectVolume:0.22},
{text:"И немного левее", actionStart:["Slider", ["70vw","60vh"], "left","150","medium", 1.7]},
]},
{scene:true, img:phoebeCunnilingus21, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].nameRu, position:"center",
phrases:[
{text:"ДаАа", soundEffectPre:moan4, soundEffectVolume:0.2},
{text:"И опять немного пониже", actionStart:["Slider", ["70vw","50vh"], "down","250","low", 1.7]},
]},
{scene:true, img:phoebeCunnilingus19, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].nameRu, position:"center",
phrases:[
{text:"ДааАа, вот тут вот", soundEffectPre:moan7, soundEffectVolume:0.2},
]},
{scene:true, img:phoebeCunnilingus22, changeScene:true, slowMode:true},
{scene:true, name:characters["empty"].nameRu, position:"center",
phrases:[
{text:"*БЗЗЗ*", vibration:[200, 200, 300, 200, 400, 200, 1000], autoPlay:700, soundEffectPre:vibrator, soundEffectVolume:0.5},
]},
{scene:true, img:phoebeCunnilingus23, changeScene:true, slowMode:true},
{scene:true, name:characters["dick"].nameRu, position:"center",
phrases:[
{text:"Хмм? Что это?", autoPlay:2500},
]},
{scene:true, img:phoebeCunnilingus24, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].nameRu, position:"center",
phrases:[
{text:"Мисс Райдер дала мне эту штучку..", autoPlay:1500},
{text:"Эта пчелка нам немного поможет"},
]},
{scene:true, name:characters["dick"].nameRu, position:"center",
phrases:[
{text:"Дак вот откуда был этот звук...", autoPlay:2500},
]},
{scene:true, img:phoebeCunnilingus25, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].nameRu, position:"center",
phrases:[
{text:"Ахах, да, я просто проверяла, работает ли он", autoPlay:1500},
]},
{scene:true, img:phoebeCunnilingus26, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].nameRu, position:"center",
phrases:[
{text:"Пожалуйста, не останавливайся", actionStart:["Hold", ["45vw","75vh"], , , , 3.3], musicChangeSettings:[0.2, 700], musicChangeSpeed:[0.95,700], ambientChangeSpeed:[0.95,700]},
]},
{scene:true, img:phoebeCunnilingus27, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].nameRu, position:"center",
phrases:[
{text:"Господи, я такая мокрая...", autoPlay:700, soundEffectPre:moan10, soundEffectVolume:0.4},
{text:"СильнЕе!", actionStart:["Hold", ["25vw","65vh"], , , , 3], musicChangeSettings:[0.25, 500], musicChangeSpeed:[0.98,300], ambientChangeSpeed:[0.98,300]},
]},
{scene:true, img:phoebeCunnilingus28, changeScene:true, slowMode:true, gallery:gallery[28]},
{scene:true, name:characters["phoebe"].nameRu, position:"center",
phrases:[
{text:"ОО ДАА!", achievement:achievements[19], autoPlay:2000, musicChangeSettings:[0.3, 500], musicChangeSpeed:[1,200], ambientChangeSpeed:[1,200], soundEffectPre:moan12, soundEffectVolume:0.7},
{text:"Ричард, Ричард, ты ювелир..."},
{text:"Пожалуйста, продолжай..", actionStart:["Slider", ["65vw","50vh"], "left","200","hard", 1.8], autoPlay:500},
]},
{scene:true, img:phoebeCunnilingus29, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].nameRu, position:"center",
phrases:[
{text:"Мм-хммм", actionStart:["Slider", ["35vw","40vh"], "down","220","hard", 2.3], soundEffectPre:moan6, soundEffectVolume:0.7},
]},
{scene:true, img:phoebeCunnilingus30, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].nameRu, position:"center",
phrases:[
{text:"АХ БОЖЕ!!", achievement:achievements[21], achievementConditionValue:[true], soundEffectPre:moan5, soundEffectVolume:0.8},
]},
{scene:true, img:phoebeCunnilingus31, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].nameRu, position:"center",
phrases:[
{text:"Дик...", autoPlay:800},
{text:"Я...", autoPlay:1400},
{text:"Я скоро!", autoPlay:600},
]},
{scene:true, endOfScene:true, time:10, skip:true},
{endOfNovel:true}
]},

{novel:true, background:phoebeCumming, startCoordinates:100,
script:[
  {scene:true, img:phoebeCumming, start:true, time:300, skip:true, gallery:gallery[29], ambientStart:natureAmbient, loopTimeAmbient:300, ambientSettings:[0.3, 1200]},
  {scene:true, name:characters["phoebe"].nameRu, position:"center",
  phrases:[
  {text:"Можешь, пожалуйста.. закрыть глаза?"},
  {text:"Я немного стесняюсь.. Мое лицо..", answers:["Закрыть глаза","Смотреть"], timer:3, phoebeUncomfortableCondition:[0.50, "Закрыть глаза", ["Закрыть глаза(no finish)", 3]]},
  ]},
  {option:"Закрыть глаза", start:true},
  {scene:true, blackScreen:true, startBS:true, wait:800},
  {scene:true, name:characters["phoebe"].nameRu, position:"center",
  phrases:[
  {text:"О да, оо даа, дааа", ambientChangeSettings:[0.1, 1000], vibration:[1200], soundEffectPre:moan7, soundEffectVolume:0.5},
  {text:"Божечки!"},
  {text:"Ммммм", vibration:[300, 200, 300, 500, 300, 1000], soundEffectPre:moan11, soundEffectVolume:1},
  {text:"Ннннгмпх", soundEffectPre:moan13, soundEffectVolume:1},
  {text:"Ууфффф", vibration:[700, 300, 300, 200, 300, 200, 1000, 600, 1000, 100, 400, 100, 200], soundEffectPre:moan14, soundEffectVolume:1},
  ]},
  {scene:true, img:phoebeCumming15, changeScene:true},
  {scene:true, name:characters["phoebe"].nameRu, position:"center",
  phrases:[
  {text:"Ёёёбушки-воробушки.."},
  {text:"Все, можешь смотреть...", vibrationCancel:true},
  ]},
  {scene:true, blackScreen:true, endBS:true},
  {scene:true, name:characters["phoebe"].nameRu, position:"center",
  phrases:[
  {text:"Это было хорошо-о-о...", ambientChangeSettings:[0.2, 1000]},
  ]},
  {scene:true, img:phoebeCumming2, changeScene:true},
  {scene:true, name:characters["phoebe"].nameRu, position:"center",
  phrases:[
  {text:"Теперь домашка точно выполнена", achievement:achievements[20]},
  {text:"Спасибо, что помог"},
  {text:"И вообще, что думал о моем комфорте.."},
  {text:"Я теперь знаю, что мне и правда нравится.."},
  ]},
  {scene:true, img:phoebeCumming4, changeScene:true},
  {scene:true, name:characters["phoebe"].nameRu, position:"center",
  phrases:[
  {text:"Когда меня слышат и проявляют заботу.."},
  ]},
  {scene:true, img:phoebeCumming3, changeScene:true},
  {scene:true, name:characters["phoebe"].nameRu, position:"center",
  phrases:[
  {text:"Ну и куни само собой, ахахах"},
  ]},
  {scene:true, img:phoebeCumming13, changeScene:true},
  {scene:true, name:characters["empty"].nameRu, position:"center",
  phrases:[
  {text:"*дзынь дзынь*", vibration:[200, 200, 200], soundEffectPre:notificationSound, soundEffectVolume:0.2},
  {text:"Ёмаё!"},
  ]},
  {scene:true, img:phoebeCumming14, changeScene:true},
  {scene:true, name:characters["empty"].nameRu, position:"center",
  phrases:[
  {text:"А сколько время?!"},
  {text:"Мы что.."},
  ]},
  {scene:true, img:phoebeCumming12, changeScene:true},
  {scene:true, name:characters["empty"].nameRu, position:"center",
  phrases:[
  {text:"Мы пропустили занятие! Бляяяха-муха"},
  {text:"Подашь, пожалуйста, мой телефон?"},
  ]},
  {option:"Закрыть глаза", endOfOption:true},

  {option:"Смотреть", start:true},
  {scene:true, name:characters["phoebe"].nameRu, position:"center",
  phrases:[
  {text:"Мммм", soundEffectPre:moan6, soundEffectVolume:0.3},
  {text:"...", soundEffectPre:moan13, soundEffectVolume:0.3},
  {text:"...", soundEffectPre:moan15, soundEffectVolume:0.8},
  ]},
  {scene:true, img:phoebeCumming5, changeScene:true},
  {scene:true, name:characters["phoebe"].nameRu, position:"center",
  phrases:[
  {text:"Да блин"},
  {text:"Фууфф"},
  ]},
  {scene:true, img:phoebeCumming6, changeScene:true},
  {scene:true, name:characters["phoebe"].nameRu, position:"center",
  phrases:[
  {text:"Я была так близко.."},
  {text:"Я как будто бы не могу расслабиться до конца, в плане эмоционально"},
  ]},
  {scene:true, img:phoebeCumming7, changeScene:true},
  {scene:true, name:characters["phoebe"].nameRu, position:"center",
  phrases:[
  {text:"Ладно, зато теперь я точно знаю, что мне нравится, а чего не хватает"},
  ]},
  {scene:true, img:phoebeCumming8, changeScene:true},
  {scene:true, name:characters["phoebe"].nameRu, position:"center",
  phrases:[
  {text:"Так чтоо, думаю, дз все равно выполнено!"},
  {text:"Спасибо, что помог"},
  ]},
  {scene:true, img:phoebeCumming9, changeScene:true},
  {scene:true, name:characters["phoebe"].nameRu, position:"center",
  phrases:[
  {text:"Было очень приятно.."},
  ]},
  {scene:true, img:phoebeCumming8, changeScene:true},
  {scene:true, name:characters["phoebe"].nameRu, position:"center",
  phrases:[
  {text:"В смысле что помог.. Ну и сам процесс тоже, конечно"},
  ]},
  {scene:true, img:phoebeCumming10, changeScene:true},
  {scene:true, name:characters["empty"].nameRu, position:"center",
  phrases:[
  {text:"*дзынь дзынь*", vibration:[200, 200, 200], soundEffectPre:notificationSound, soundEffectVolume:0.2},
  {text:"Ёмаё!"},
  ]},
  {scene:true, img:phoebeCumming11, changeScene:true},
  {scene:true, name:characters["empty"].nameRu, position:"center",
  phrases:[
  {text:"А сколько время?!"},
  {text:"Мы что.."},
  ]},
  {scene:true, img:phoebeCumming7, changeScene:true},
  {scene:true, name:characters["empty"].nameRu, position:"center",
  phrases:[
  {text:"Мы пропустили занятие! Бляяяха-муха"},
  {text:"Подашь, пожалуйста, мой телефон?"},
  ]},
  {option:"Смотреть", endOfOption:true},

  {option:"Skip", start:true},
  {scene:true, name:characters["phoebe"].nameRu, position:"center",
  phrases:[
  {text:"Ммм-хм", soundEffectPre:moan6, soundEffectVolume:0.3},
  {text:"...", soundEffectPre:moan13, soundEffectVolume:0.3},
  {text:"...", soundEffectPre:moan15, soundEffectVolume:0.8},
  ]},
  {scene:true, img:phoebeCumming5, changeScene:true},
  {scene:true, name:characters["phoebe"].nameRu, position:"center",
  phrases:[
  {text:"Да блин"},
  {text:"Фууфф"},
  ]},
  {scene:true, img:phoebeCumming6, changeScene:true},
  {scene:true, name:characters["phoebe"].nameRu, position:"center",
  phrases:[
  {text:"Я была так близко.."},
  {text:"Я как будто бы не могу расслабиться до конца, в плане эмоционально"},
  ]},
  {scene:true, img:phoebeCumming7, changeScene:true},
  {scene:true, name:characters["phoebe"].nameRu, position:"center",
  phrases:[
  {text:"Ладно, зато теперь я точно знаю, что мне нравится, а чего не хватает"},
  ]},
  {scene:true, img:phoebeCumming8, changeScene:true},
  {scene:true, name:characters["phoebe"].nameRu, position:"center",
  phrases:[
  {text:"Так чтоо, думаю, дз все равно выполнено!"},
  {text:"Спасибо, что помог"},
  ]},
  {scene:true, img:phoebeCumming9, changeScene:true},
  {scene:true, name:characters["phoebe"].nameRu, position:"center",
  phrases:[
  {text:"Было очень приятно.."},
  ]},
  {scene:true, img:phoebeCumming8, changeScene:true},
  {scene:true, name:characters["phoebe"].nameRu, position:"center",
  phrases:[
  {text:"В смысле что помог.. Ну и сам процесс тоже, конечно"},
  ]},
  {scene:true, img:phoebeCumming10, changeScene:true},
  {scene:true, name:characters["empty"].nameRu, position:"center",
  phrases:[
  {text:"*дзынь дзынь*", vibration:[200, 200, 200], soundEffectPre:notificationSound, soundEffectVolume:0.2},
  {text:"Ёмаё!"},
  ]},
  {scene:true, img:phoebeCumming11, changeScene:true},
  {scene:true, name:characters["empty"].nameRu, position:"center",
  phrases:[
  {text:"А сколько время?!"},
  {text:"Мы что.."},
  ]},
  {scene:true, img:phoebeCumming7, changeScene:true},
  {scene:true, name:characters["empty"].nameRu, position:"center",
  phrases:[
  {text:"Мы пропустили занятие! Бляяяха-муха"},
  {text:"Подашь, пожалуйста, мой телефон?"},
  ]},
  {option:"Skip", endOfOption:true},

  {option:"Закрыть глаза(no finish)", start:true},
  {scene:true, blackScreen:true, startBS:true, wait:800},
  {scene:true, name:characters["phoebe"].nameRu, position:"center",
  phrases:[
  {text:"Мммм", ambientChangeSettings:[0.1, 1000], soundEffectPre:moan6, soundEffectVolume:0.3},
  {text:"...", soundEffectPre:moan13, soundEffectVolume:0.3},
  {text:"...", soundEffectPre:moan15, soundEffectVolume:0.8},
  {text:"Уфф"},
  {text:"Думаю, можешь уже открывать глаза..."},
  ]},
  {scene:true, img:phoebeCumming6, changeScene:true},
  {scene:true, blackScreen:true, endBS:true},
  {scene:true, name:characters["phoebe"].nameRu, position:"center",
  phrases:[
  {text:"Я была так близко..", ambientChangeSettings:[0.2, 1000]},
  {text:"Я как будто бы не могу расслабиться до конца, в плане эмоционально"},
  ]},
  {scene:true, img:phoebeCumming7, changeScene:true},
  {scene:true, name:characters["phoebe"].nameRu, position:"center",
  phrases:[
  {text:"Ладно, зато теперь я точно знаю, что мне нравится, а чего не хватает"},
  ]},
  {scene:true, img:phoebeCumming8, changeScene:true},
  {scene:true, name:characters["phoebe"].nameRu, position:"center",
  phrases:[
  {text:"Так чтоо, думаю, дз все равно выполнено!"},
  {text:"Спасибо, что помог"},
  ]},
  {scene:true, img:phoebeCumming9, changeScene:true},
  {scene:true, name:characters["phoebe"].nameRu, position:"center",
  phrases:[
  {text:"Было очень приятно.."},
  ]},
  {scene:true, img:phoebeCumming8, changeScene:true},
  {scene:true, name:characters["phoebe"].nameRu, position:"center",
  phrases:[
  {text:"В смысле что помог.. Ну и сам процесс тоже, конечно"},
  ]},
  {scene:true, img:phoebeCumming10, changeScene:true},
  {scene:true, name:characters["empty"].nameRu, position:"center",
  phrases:[
  {text:"*дзынь дзынь*", vibration:[200, 200, 200], soundEffectPre:notificationSound, soundEffectVolume:0.2},
  {text:"Ёмаё!"},
  ]},
  {scene:true, img:phoebeCumming11, changeScene:true},
  {scene:true, name:characters["empty"].nameRu, position:"center",
  phrases:[
  {text:"А сколько время?!"},
  {text:"Мы что.."},
  ]},
  {scene:true, img:phoebeCumming7, changeScene:true},
  {scene:true, name:characters["empty"].nameRu, position:"center",
  phrases:[
  {text:"Мы пропустили занятие! Бляяяха-муха"},
  {text:"Подашь, пожалуйста, мой телефон?"},
  ]},
  {option:"Смотреть(no finish)", endOfOption:true, endOfOptions:true},

  {endOfNovel:true}
]},

{groupChat:true, from:{name:"CUMанда", photo:theWets, members:3 },
 messages: [
   {text:"Ребята, вы где?", from:'messageFromThem', name:"Willinator", avatar:willieChat, answers:["Я помогал Фиби кое с чем","Я проспал"]},
   {text:"Ой, надеюсь, все хорошо",from:'messageFromThem', name:"Willinator", avatar:willieChat, answered:"Я помогал Фиби кое с чем"},
   {text:"Дааа, конечно, конечно..",from:'messageFromThem', name:"Willinator", avatar:willieChat, answered:"Я проспал"},
   {text:"Вместе с Фиби? хехе",from:'messageFromThem', name:"Willinator", avatar:willieChat, answered:"Я проспал", endofAnswer:true},
   {text:"Мы только закончили и ЭТО БЫЛ ТРЕШ",from:'messageFromThem', name:"Willinator", avatar:willieChat},
   {text:"Да блин! Что мы пропустили?",from:'messageFromThem', name:"Фиби", avatar:phoebeChat},
   {text:"Нуу, начнем с..",from:'messageFromThem', name:"Willinator", avatar:willieChat},
   {text:"Истории Виолетты про мастурбацию пяткой (она даже гайд составила)",from:'messageFromThem', name:"Willinator", avatar:willieChat},
   {text:"Очень детальный.. Со всеми подробностями",from:'messageFromThem', name:"Willinator", avatar:willieChat},
   {text:"А Говард.. Хотя, думаю, вам лучше не знать",from:'messageFromThem', name:"Willinator", avatar:willieChat},
   {text:"Потом у нас была мужская анатомия ииии угадайте кто сегодня был на практике???",from:'messageFromThem', name:"Willinator", avatar:willieChat},
   {text:"Это было ЕБАТЬ(точнее сказать обдрочиться) КАК КРУТО…",from:'messageFromThem', name:"Willinator", avatar:willieChat},
   {text:"Мисс Райдер рассказывала про мужской оргазм...",from:'messageFromThem', name:"Willinator", avatar:willieChat},
   {text:"С моей помощью... если вы понимаете, о чем я",from:'messageFromThem', name:"Willinator", avatar:willieChat},
   {text:"Могу сказать, у нее золотые ручки...",from:'messageFromThem', name:"Willinator", avatar:willieChat},
   {text:"Да и ножки вообще-то тоже...",from:'messageFromThem', name:"Willinator", avatar:willieChat},
   {text:"Подожди, она тебе это что..",from:'messageFromThem', name:"Фиби", avatar:phoebeChat},
   {text:"Ногами делала?",from:'messageFromThem', name:"Phoebe", avatar:phoebeChat},
   {text:"Я знал, что вы не поверите!",from:'messageFromThem', name:"Willinator", avatar:willieChat},
   {text:"Пиздец!! Ахренеть!!",from:'messageFromThem', name:"Фиби", avatar:phoebeChat},
   {text:"Она наверное так расстроилась, что Дик сегодня не дошел (до оргазма)",from:'messageFromThem', name:"Фиби", avatar:phoebeChat},
   {text:"Любимчик;3",from:'messageFromThem', name:"Фиби", avatar:phoebeChat},
   {text:"Ахахах, кстати, да, она спрашивала где он",from:'messageFromThem', name:"Willinator", avatar:willieChat},
   {text:"Да да да я говорю!!!",from:'messageFromThem', name:"Фиби", avatar:phoebeChat},
   {text:"Ты писал конспект?",from:'messageFromThem', name:"Фиби", avatar:phoebeChat},
   {text:"Лучше! У меня есть видео.",from:'messageFromThem', name:"Willinator", avatar:willieChat},
   {text:"Я скину через пару минут!",from:'messageFromThem', name:"Willinator", avatar:willieChat},
   {text:"Спасибки!",from:'messageFromThem', name:"Фиби", avatar:phoebeChat},
   {text:"Думаю нам с Ричардом надо бы нагнать материал, что думаешь?",from:'messageFromThem', name:"Фиби", avatar:phoebeChat, answers:["Конечно!","Думаешь?"]},
   {text:"Ураа! Всегда было интересно как эта... штуковина🍆 работает..",from:'messageFromThem', name:"Фиби", avatar:phoebeChat, answered:"Конечно!"},
   {text:"Так и знала, что ради мисс Райдер ты все выучишь ахаха",from:'messageFromThem', name:"Фиби", avatar:phoebeChat, answered:"Конечно!"},
   {text:"Ну тогда договорились😏",from:'messageFromThem', name:"Фиби", avatar:phoebeChat, answered:"Конечно!"},
   {text:"Ну конечно!",from:'messageFromThem', name:"Фиби", avatar:phoebeChat, answered:"Думаешь?"},
   {text:"А иначе мисс Райдер расстроится, ты ведь этого не хочешь?",from:'messageFromThem', name:"Фиби", avatar:phoebeChat, answered:"Думаешь?"},
   {text:"Ну и вообще, думаю, может быть... интересно",from:'messageFromThem', name:"Фиби", avatar:phoebeChat, answered:"Думаешь?", endofAnswer:true},
   {text:"Удачи вам! Я пойду, бабуля приготовила мой любимый супчик! Вот это денёк!",from:'messageFromThem', name:"Willinator", avatar:willieChat, endOfChat:true}
]
},

{blackScreen:true, txt:["<h2>Это конец третьей главы! Надеюсь вам понравилось!</h2> <br/> Пишите отзывы в комментариях;)","<h2>Четвертая глава(Восполнение пробелов) уже доступна на патреоне, там же вы найдете информацию о предстоящих обновлениях, WIPы, опросы и эксклюзивный контент!</h2>","<h2>Пожалуйста, поддержите меня, если у вас есть такая возможность! </h2> Ваша поддержка позволяет продолжать работу над игрой и делать ее лучше! </br> Спасибо!💖"], end:true},

];

export default chapter3ru;
